/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

const Copyright = ({ name }) => {
	return (
		<Typography component={'span'} variant="body2" color="textSecondary" align="center">
			{'Copyright © '}
			<Link color="inherit" href="#" to="#">
				{name}
			</Link>{' '}
			{new Date().getFullYear()}
			{'.'}
		</Typography>
	);
};

export default Copyright;
